import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import useRandomId from 'hooks/useRandomId';
import CtaLink from 'components/essentials/Cta/CtaLink';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { getTempUserIdCookie } from 'commons/localStorage';
import CtaButton from 'components/essentials/Cta/CtaButton';
import { SIGNUP, RESET_PASSWORD } from 'mocks/mutations';
import IconClose from 'components/icons/iconClose';
import { sendAnalyticsIdentifyEvent } from 'commons/analytics';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { INVALID_NAME_CHARACTERS_REGEX, EMAIL_REGEX } from 'commons/constants';
import useSetAuthTokenAndUser from 'data-hooks/useUserData/useSetAuthTokenAndUser';
const initCaps = str => str && str[0].toUpperCase() + str.slice(1);
const IconTick = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g stroke="none" strokeWidth="1.25" fill="none" fillRule="evenodd"><g className="tick-stroke" transform="translate(0.000000, 1.000000)"><polyline points="0 3.6732398 3.4439402 7 11 0" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={11} height={9} viewBox="0 0 11 9" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const CreatePassword = t0 => {
  const $ = _c(133);
  const {
    mode: t1,
    state,
    actions,
    match,
    history
  } = t0;
  const mode = t1 === undefined ? "signup" : t1;
  const [formError, setFormError] = useState(null);
  const [showResetPassword, setShowResetPassword] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [firstNameValidations, setFirstNameValidations] = useState(t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [lastNameValidations, setLastNameValidations] = useState(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [nameErrorMsgs, setNameErrorMsgs] = useState(t4);
  const [emailError, setEmailError] = useState(false);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const [passwordValidations, setPasswordValidations] = useState(t5);
  const passwordInfoId = useRandomId("CreatePassword__info");
  const currentPage = useUserCurrentPageType();
  let t6;
  if ($[4] !== actions) {
    t6 = evt => {
      actions.onPasswordChange(evt);
      const {
        value
      } = evt.target;
      if (value) {
        setPasswordValidations({
          charLen: value.length >= 6,
          hasLower: /[a-z]/.test(value),
          hasUpper: /[A-Z]/.test(value),
          hasNumber: /[0-9]/.test(value)
        });
      } else {
        setPasswordValidations({});
      }
    };
    $[4] = actions;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const onPasswordChange = t6;
  let t7;
  if ($[6] !== actions) {
    t7 = evt_0 => {
      actions.onFirstNameChange(evt_0);
      const value_0 = evt_0.target.value?.length > 0 ? evt_0.target.value.trim() : "";
      setFirstNameValidations({
        isTouched: true,
        isRequired: !value_0,
        minLength: value_0.length < 2,
        hasInvalidCharacters: INVALID_NAME_CHARACTERS_REGEX.test(value_0)
      });
    };
    $[6] = actions;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const onFirstNameChange = t7;
  let t8;
  if ($[8] !== actions) {
    t8 = evt_1 => {
      actions.onLastNameChange(evt_1);
      const value_1 = evt_1.target.value?.length > 0 ? evt_1.target.value.trim() : "";
      setLastNameValidations({
        isTouched: true,
        isRequired: !value_1,
        minLength: value_1.length < 2,
        hasInvalidCharacters: INVALID_NAME_CHARACTERS_REGEX.test(value_1)
      });
    };
    $[8] = actions;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const onLastNameChange = t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = evt_2 => {
      if (!EMAIL_REGEX.test(evt_2.target.value)) {
        setEmailError(true);
        return;
      }
      setEmailError(false);
    };
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const checkEmailInput = t9;
  const setAuthTokenAndUser = useSetAuthTokenAndUser();
  let t10;
  if ($[11] !== actions || $[12] !== currentPage || $[13] !== setAuthTokenAndUser) {
    t10 = {
      onCompleted: async data => {
        const {
          signup
        } = data;
        if (!signup || signup.errors) {
          setFormError(get(signup, "errors.0.message", "Unable to sign up please try again"));
        }
        if (signup.user) {
          actions.onSignUp(signup.user);
          const {
            access_token,
            refresh_token,
            email,
            id,
            last_name,
            first_name,
            group_id,
            is_designer,
            user_discount
          } = signup.user;
          await setAuthTokenAndUser({
            access_token,
            email,
            first_name,
            group_id,
            id,
            is_designer,
            is_impersonate: false,
            last_name,
            refresh_token,
            user_discount
          });
          const heapData = {
            userid: signup?.user?.id?.toString(),
            event: "Create Account",
            properties: "Website"
          };
          avo.emailAcquired({
            userId_: heapData.userid.toString(),
            email,
            location: currentPage,
            optedInMarketing: true,
            backendEmail: email,
            component: avo.Component.ACCOUNT_CREATION,
            talkativeCustomerId: ""
          });
          avo.accountCreated({
            userId_: heapData.userid.toString(),
            location: currentPage
          });
          sendAnalyticsIdentifyEvent(heapData.userid, {
            first_name,
            last_name,
            email
          });
        }
      }
    };
    $[11] = actions;
    $[12] = currentPage;
    $[13] = setAuthTokenAndUser;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const [signUp, t11] = useMutation(SIGNUP, t10);
  const {
    loading: signUpLoading
  } = t11;
  let t12;
  if ($[15] !== actions || $[16] !== history) {
    t12 = {
      onCompleted: async data_0 => {
        if (data_0 && data_0.resetPassword) {
          if (data_0.resetPassword.success === true) {
            actions.onForgotPasswordSuccess();
            history.push("/sign-in");
          } else {
            setFormError(data_0.resetPassword.message);
            if (data_0.resetPassword.message?.includes("20007")) {
              setShowResetPassword(true);
            }
          }
        } else {
          setFormError("Unable to reset password.");
        }
      }
    };
    $[15] = actions;
    $[16] = history;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const [resetPassword, t13] = useMutation(RESET_PASSWORD, t12);
  const {
    loading: resetPasswordLoading
  } = t13;
  let t14;
  if ($[18] !== firstNameValidations.isRequired || $[19] !== firstNameValidations.isTouched || $[20] !== firstNameValidations.minLength || $[21] !== lastNameValidations.isRequired || $[22] !== lastNameValidations.isTouched || $[23] !== lastNameValidations.minLength || $[24] !== passwordValidations.charLen || $[25] !== passwordValidations.hasLower || $[26] !== passwordValidations.hasNumber || $[27] !== passwordValidations.hasUpper || $[28] !== signUp || $[29] !== state.email || $[30] !== state.first_name || $[31] !== state.last_name || $[32] !== state.password) {
    t14 = async () => {
      if (!firstNameValidations.isTouched || firstNameValidations.isRequired || firstNameValidations.minLength) {
        setFormError("First name is invalid");
        return;
      }
      if (!lastNameValidations.isTouched || lastNameValidations.isRequired || lastNameValidations.minLength) {
        setFormError("Last name is invalid");
        return;
      }
      if (!(passwordValidations.charLen && passwordValidations.hasLower && passwordValidations.hasUpper && passwordValidations.hasNumber)) {
        setFormError("Password is invalid");
        return;
      }
      await signUp({
        variables: {
          email: state.email.trim(),
          password: state.password,
          first_name: initCaps(state.first_name),
          last_name: initCaps(state.last_name),
          tempUserId: getTempUserIdCookie()
        }
      });
    };
    $[18] = firstNameValidations.isRequired;
    $[19] = firstNameValidations.isTouched;
    $[20] = firstNameValidations.minLength;
    $[21] = lastNameValidations.isRequired;
    $[22] = lastNameValidations.isTouched;
    $[23] = lastNameValidations.minLength;
    $[24] = passwordValidations.charLen;
    $[25] = passwordValidations.hasLower;
    $[26] = passwordValidations.hasNumber;
    $[27] = passwordValidations.hasUpper;
    $[28] = signUp;
    $[29] = state.email;
    $[30] = state.first_name;
    $[31] = state.last_name;
    $[32] = state.password;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const doSignUp = t14;
  let t15;
  if ($[34] !== match.params.reset_token || $[35] !== resetPassword || $[36] !== state.password) {
    t15 = async () => {
      await resetPassword({
        variables: {
          new_password: state.password,
          confirm_new_password: state.password,
          token: match.params.reset_token
        }
      });
    };
    $[34] = match.params.reset_token;
    $[35] = resetPassword;
    $[36] = state.password;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const doResetPassword = t15;
  let t16;
  if ($[38] !== doResetPassword || $[39] !== doSignUp || $[40] !== mode) {
    t16 = evt_3 => {
      evt_3.preventDefault();
      evt_3.stopPropagation();
      if (mode === "signup") {
        doSignUp();
      } else {
        doResetPassword();
      }
      return false;
    };
    $[38] = doResetPassword;
    $[39] = doSignUp;
    $[40] = mode;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const onSubmit = t16;
  let t17;
  if ($[42] !== firstNameValidations.hasInvalidCharacters || $[43] !== firstNameValidations.isRequired || $[44] !== firstNameValidations.isTouched || $[45] !== firstNameValidations.minLength || $[46] !== lastNameValidations.hasInvalidCharacters || $[47] !== lastNameValidations.isRequired || $[48] !== lastNameValidations.isTouched || $[49] !== lastNameValidations.minLength) {
    t17 = () => {
      let firstNameErrorMsg = "";
      let lastNameErrorMsg = "";
      if (firstNameValidations.isTouched) {
        firstNameErrorMsg = firstNameValidations.isRequired ? "First name is required" : firstNameValidations.minLength ? "Min. 2 chars are required" : firstNameValidations.hasInvalidCharacters ? "Please remove invalid characters from name" : null;
      }
      if (lastNameValidations.isTouched) {
        lastNameErrorMsg = lastNameValidations.isRequired ? "Last name is required" : lastNameValidations.minLength ? "Min. 2 chars are required" : lastNameValidations.hasInvalidCharacters ? "Please remove invalid characters from name" : null;
      }
      setNameErrorMsgs({
        firstNameErrorMsg,
        lastNameErrorMsg
      });
    };
    $[42] = firstNameValidations.hasInvalidCharacters;
    $[43] = firstNameValidations.isRequired;
    $[44] = firstNameValidations.isTouched;
    $[45] = firstNameValidations.minLength;
    $[46] = lastNameValidations.hasInvalidCharacters;
    $[47] = lastNameValidations.isRequired;
    $[48] = lastNameValidations.isTouched;
    $[49] = lastNameValidations.minLength;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== firstNameValidations || $[52] !== lastNameValidations) {
    t18 = [firstNameValidations, lastNameValidations];
    $[51] = firstNameValidations;
    $[52] = lastNameValidations;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  useEffect(t17, t18);
  const t19 = mode === "forgot-password" ? " new " : "";
  let t20;
  if ($[54] !== t19) {
    t20 = <div className="text-xl font-bold">Create a {t19} password</div>;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== actions || $[57] !== emailError || $[58] !== mode || $[59] !== nameErrorMsgs || $[60] !== onFirstNameChange || $[61] !== onLastNameChange || $[62] !== state.email || $[63] !== state.first_name || $[64] !== state.last_name || $[65] !== state.showEmailError) {
    t21 = mode === "signup" && <><LabeledTextInput name="email" value={state.email.trim()} label="Email address" autoComplete="username" autoFocus={!state.email} onChange={evt_4 => {
        setEmailError(false);
        actions.onEmailChange(evt_4);
      }} onBlur={checkEmailInput} errorMessage={state.showEmailError || emailError ? "Email address is invalid" : null} /><LabeledTextInput name="first_name" label="First name" value={state.first_name} autoFocus={!!state.email} autoComplete="given-name" onChange={onFirstNameChange} errorMessage={nameErrorMsgs.firstNameErrorMsg || ""} /><LabeledTextInput name="last_name" label="Last name" value={state.last_name} autoComplete="family-name" onChange={onLastNameChange} errorMessage={nameErrorMsgs.lastNameErrorMsg || ""} /></>;
    $[56] = actions;
    $[57] = emailError;
    $[58] = mode;
    $[59] = nameErrorMsgs;
    $[60] = onFirstNameChange;
    $[61] = onLastNameChange;
    $[62] = state.email;
    $[63] = state.first_name;
    $[64] = state.last_name;
    $[65] = state.showEmailError;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="pb-[5px]">Your password must contain at least</div>;
    $[67] = t22;
  } else {
    t22 = $[67];
  }
  const t23 = passwordValidations.charLen === true;
  const t24 = passwordValidations.charLen === false;
  let t25;
  if ($[68] !== t23 || $[69] !== t24) {
    t25 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t23,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t24
    });
    $[68] = t23;
    $[69] = t24;
    $[70] = t25;
  } else {
    t25 = $[70];
  }
  let t26;
  if ($[71] !== passwordValidations.charLen) {
    t26 = passwordValidations.charLen ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[71] = passwordValidations.charLen;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  let t27;
  if ($[73] !== t25 || $[74] !== t26) {
    t27 = <div className={t25}>{t26}6 characters</div>;
    $[73] = t25;
    $[74] = t26;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  const t28 = passwordValidations.hasUpper === true;
  const t29 = passwordValidations.hasUpper === false;
  let t30;
  if ($[76] !== t28 || $[77] !== t29) {
    t30 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t28,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t29
    });
    $[76] = t28;
    $[77] = t29;
    $[78] = t30;
  } else {
    t30 = $[78];
  }
  let t31;
  if ($[79] !== passwordValidations.hasUpper) {
    t31 = passwordValidations.hasUpper ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[79] = passwordValidations.hasUpper;
    $[80] = t31;
  } else {
    t31 = $[80];
  }
  let t32;
  if ($[81] !== t30 || $[82] !== t31) {
    t32 = <div className={t30}>{t31}1 uppercase letter</div>;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  const t33 = passwordValidations.hasLower === true;
  const t34 = passwordValidations.hasLower === false;
  let t35;
  if ($[84] !== t33 || $[85] !== t34) {
    t35 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t33,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t34
    });
    $[84] = t33;
    $[85] = t34;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== passwordValidations.hasLower) {
    t36 = passwordValidations.hasLower ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[87] = passwordValidations.hasLower;
    $[88] = t36;
  } else {
    t36 = $[88];
  }
  let t37;
  if ($[89] !== t35 || $[90] !== t36) {
    t37 = <div className={t35}>{t36}1 lowercase letter</div>;
    $[89] = t35;
    $[90] = t36;
    $[91] = t37;
  } else {
    t37 = $[91];
  }
  const t38 = passwordValidations.hasNumber === true;
  const t39 = passwordValidations.hasNumber === false;
  let t40;
  if ($[92] !== t38 || $[93] !== t39) {
    t40 = cx("pb-[3px] flex items-center [&_svg_path]:fill-gray [&_svg_g.tick-stroke]:stroke-[#424242]", {
      "text-brand [&_svg_path]:!fill-brand [&_svg_g.tick-stroke]:!stroke-[#107c8c]": t38,
      "text-red [&_svg_path]:!fill-red [&_svg_g.tick-stroke]:!stroke-[#b85455]": t39
    });
    $[92] = t38;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] !== passwordValidations.hasNumber) {
    t41 = passwordValidations.hasNumber ? <IconTick className="mr-1.5" /> : <IconClose width={8} height={9} className="mr-2" />;
    $[95] = passwordValidations.hasNumber;
    $[96] = t41;
  } else {
    t41 = $[96];
  }
  let t42;
  if ($[97] !== t40 || $[98] !== t41) {
    t42 = <div className={t40}>{t41}1 number</div>;
    $[97] = t40;
    $[98] = t41;
    $[99] = t42;
  } else {
    t42 = $[99];
  }
  let t43;
  if ($[100] !== passwordInfoId || $[101] !== t27 || $[102] !== t32 || $[103] !== t37 || $[104] !== t42) {
    t43 = <div className="text-xs mb-2" id={passwordInfoId}>{t22}{t27}{t32}{t37}{t42}</div>;
    $[100] = passwordInfoId;
    $[101] = t27;
    $[102] = t32;
    $[103] = t37;
    $[104] = t42;
    $[105] = t43;
  } else {
    t43 = $[105];
  }
  let t44;
  if ($[106] !== onPasswordChange || $[107] !== passwordInfoId || $[108] !== state.password) {
    t44 = <LabeledTextInput aria-describedby={passwordInfoId} name="password" type="password" label="Password" value={state.password} autoComplete="current-password" onChange={onPasswordChange} />;
    $[106] = onPasswordChange;
    $[107] = passwordInfoId;
    $[108] = state.password;
    $[109] = t44;
  } else {
    t44 = $[109];
  }
  let t45;
  if ($[110] !== t43 || $[111] !== t44) {
    t45 = <div>{t43}{t44}</div>;
    $[110] = t43;
    $[111] = t44;
    $[112] = t45;
  } else {
    t45 = $[112];
  }
  const t46 = signUpLoading || resetPasswordLoading;
  const t47 = signUpLoading || resetPasswordLoading;
  let t48;
  if ($[113] !== t46 || $[114] !== t47) {
    t48 = <CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={t46} block={true} isLoading={t47}>Continue</CtaButton>;
    $[113] = t46;
    $[114] = t47;
    $[115] = t48;
  } else {
    t48 = $[115];
  }
  let t49;
  if ($[116] !== actions.showResetPassword || $[117] !== formError || $[118] !== showResetPassword) {
    t49 = formError && <><div className="text-sm font-bold text-red mx-0 my-[.325rem] text-center">{formError}</div>{showResetPassword && <div className="text-sm text-center"><CtaButton onClick={actions.showResetPassword} hasArrow={false} styling="link" color="brand" size="sm">Reset Password</CtaButton></div>}</>;
    $[116] = actions.showResetPassword;
    $[117] = formError;
    $[118] = showResetPassword;
    $[119] = t49;
  } else {
    t49 = $[119];
  }
  let t50;
  if ($[120] !== onSubmit || $[121] !== t21 || $[122] !== t45 || $[123] !== t48 || $[124] !== t49) {
    t50 = <form method="POST" onSubmit={onSubmit}>{t21}{t45}{t48}{t49}</form>;
    $[120] = onSubmit;
    $[121] = t21;
    $[122] = t45;
    $[123] = t48;
    $[124] = t49;
    $[125] = t50;
  } else {
    t50 = $[125];
  }
  let t51;
  if ($[126] !== actions.onLoginClick || $[127] !== mode) {
    t51 = mode === "signup" && <><div className="text-xs text-center mt-4 mx-0 mb-6 [&_a]:px-1 [&_a]:py-0">By creating an account, you are agreeing to our<CtaLink to="/privacy-policy/" color="brand" hasArrow={false} size="xs">Privacy Policy</CtaLink>You also agree to receive exclusive sales and design inspiration via email; you can unsubscribe at any time.</div><div className="text-sm text-center">Already have an account?  <CtaButton onClick={actions.onLoginClick} color="brand" styling="link" hasArrow={false} size="sm">Log in</CtaButton></div></>;
    $[126] = actions.onLoginClick;
    $[127] = mode;
    $[128] = t51;
  } else {
    t51 = $[128];
  }
  let t52;
  if ($[129] !== t20 || $[130] !== t50 || $[131] !== t51) {
    t52 = <div className="text-gray"><div className="consumer-create-password__content">{t20}{t50}{t51}</div></div>;
    $[129] = t20;
    $[130] = t50;
    $[131] = t51;
    $[132] = t52;
  } else {
    t52 = $[132];
  }
  return t52;
};
CreatePassword.propTypes = {
  mode: PropTypes.oneOf(['signup', 'forgot-password']),
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func
  }),
  match: PropTypes.object,
  state: PropTypes.object,
  actions: PropTypes.shape({
    onForgotPasswordSuccess: PropTypes.func,
    showResetPassword: PropTypes.func,
    onFirstNameChange: PropTypes.func,
    onLastNameChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
    onEmailChange: PropTypes.func,
    onLoginClick: PropTypes.func,
    onSignUp: PropTypes.func
  })
};
export default withRouter(CreatePassword);